/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_F_Current_IdInputs */

const cs_pm_f_current_id = /** @type {(inputs: Pm_F_Current_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuální ID na portálu`)
};

const en_pm_f_current_id = /** @type {(inputs: Pm_F_Current_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current portal ID`)
};

/**
* | output |
* | --- |
* | "Current portal ID" |
*
* @param {Pm_F_Current_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_f_current_id = /** @type {((inputs?: Pm_F_Current_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_F_Current_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_f_current_id(inputs)
	return cs_pm_f_current_id(inputs)
});